var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b(t.t(interpolate( gettext("Такой аккаунт Wargaming.net уже существует. %(linkS)s%(authUrl)s%(linkM)sВойти%(linkE)s."), {'linkS': '<a href="', 'linkM': '">', 'linkE': '</a>', 'authUrl': t.d("authUrl",c,p,1)||""}, true)));t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{{ ___0___ }}}\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./static-source/messages/uid_exist.html
// module id = 217
// module chunks = 4